var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabBarCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14932 1.52348L1.84305 5.27422C0.701929 6.41728 -0.233788 12.1111 6.87737 17.7103C13.8178 23.1751 18.202 22.0495 19.9827 20.9166C20.0543 20.871 20.1168 20.8151 20.173 20.7514L23.3966 17.0944C23.5792 16.8873 23.5593 16.5713 23.3521 16.3887L20.0934 13.5162C19.8858 13.3332 19.569 13.3537 19.3867 13.5619L16.524 16.8307C16.4123 16.9583 16.2436 17.0217 16.0768 16.9913C11.1593 16.0961 6.80615 10.396 6.49387 8.52491C6.4736 8.40343 6.52103 8.28482 6.60247 8.19244L9.27517 5.16042C9.45777 4.95327 9.43787 4.63732 9.23072 4.45472L5.85503 1.47903C5.64788 1.29643 5.33192 1.31633 5.14932 1.52348Z",
    stroke: "black",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabBarCall);
export default __webpack_public_path__ + "static/media/TabBarCall.3502dbf77a2229cecba48b4a809e2d22.svg";
export { ForwardRef as ReactComponent };